import script from "./ContactMap.vue?vue&type=script&setup=true&lang=js"
export * from "./ContactMap.vue?vue&type=script&setup=true&lang=js"

import "./ContactMap.vue?vue&type=style&index=0&id=956ad1d4&scoped=true&lang=css"

import exportComponent from "E:\\changjuCode\\official-web\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-956ad1d4"]])

export default __exports__